export const COURSE = 'COURSE';



// WEBPACK FOOTER //
// ./src/store/modules/course/mutation-types.js